import React from 'react';
import { motion } from 'framer-motion';
import { Check, Trophy, X } from 'lucide-react';
import { FlowSteps } from './FlowSteps';
const negatives = ['This is not a random collection of MMA drills.', 'This is not a generic martial arts manual filled with theory you still need to convert into a real session.', 'And it is not a collection of disconnected striking, wrestling and grappling techniques.'];
const mmaFlow = ['Stance & Distance', 'Striking', 'Clinch', 'Takedowns', 'Ground', 'Transitions', 'Complete Application'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-black relative overflow-hidden border-y border-zinc-800" data-id="element-236" data-mp="182knm4lq5axx">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-amber-400/70" data-id="element-237" data-mp="13zxzoes6ca60" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-238" data-mp="2jggci52fky2c">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-239" data-mp="2jjaw5udmeeup">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-amber-400/60 bg-amber-400/10 text-amber-400 mb-5" data-id="element-240" data-mp="2gusatmv5pt07">
            <Trophy size={26} aria-hidden="true" data-id="element-241" data-mp="2kwwxg1n6tpdc" />
          </div>
          <h2 className="text-2xl md:text-4xl font-black uppercase mb-4 text-white" data-id="element-242" data-mp="2pvqeg41onyi9">
            The complete system for MMA coaches worldwide
          </h2>
          <h3 className="text-xl font-extrabold text-amber-400 mb-3" data-id="element-243" data-mp="1t3eez6xsrfah">MMA COACH READY</h3>
          <p className="font-display font-bold uppercase tracking-wide text-sm md:text-base text-zinc-300 mb-10" data-id="element-244" data-mp="1x4q83mfvqinf">
            6 Complete Volumes • 150 Ready-to-Coach Sessions • 5 Professional Bonus Guides
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-245" data-mp="19hrv4yqyxsu9">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-zinc-900 p-6 rounded-2xl border border-zinc-800" data-id="element-246" data-mp="19f5msww979az">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-247" data-mp="2qi94hqff43sz">
                <X className="text-red-500 shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-248" data-mp="2mhfhr0dpov1o" />
                <p className="text-zinc-400 text-sm" data-id="element-249" data-mp="1ys385zeh2kyu">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-zinc-900 p-6 rounded-2xl border-2 border-amber-400/70" data-id="element-250" data-mp="1tu1nxb5b8fls">
            <div className="flex items-start gap-3" data-id="element-251" data-mp="3j6wt9vzdlbba">
              <Check className="text-amber-400 shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-252" data-mp="3e951d1yqdp73" />
              <p className="text-white font-display font-extrabold uppercase text-base leading-snug" data-id="element-253" data-mp="3mq5ehcuzdkg3">
                MMA Coach Ready is a complete 6-in-1 visual coaching system.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="mt-10" data-id="element-254" data-mp="3ct9ejvj5e6n5">
          <p className="text-zinc-300 text-sm mb-4" data-id="element-255" data-mp="3cu2b63oe7frk">It is designed around the real flow of MMA:</p>
          <FlowSteps steps={mmaFlow} tone="dark" label="The real flow of MMA" data-id="element-256" data-mp="3ht5bjatfgxt7" />
          <p className="text-base md:text-lg text-zinc-300 mt-6" data-id="element-257" data-mp="9br6bmzgqxm7">
            Everything is organized to help you teach MMA as one connected system.
          </p>
        </div>
      </div>
    </section>;
}